export enum RegionTmsSyncSchedulerTime {
    UTC_00 = 'UTC_00',
    UTC_01 = 'UTC_01',
    UTC_02 = 'UTC_02',
    UTC_03 = 'UTC_03',
    UTC_04 = 'UTC_04',
    UTC_05 = 'UTC_05',
    UTC_06 = 'UTC_06',
    UTC_07 = 'UTC_07',
    UTC_08 = 'UTC_08',
    UTC_09 = 'UTC_09',
    UTC_10 = 'UTC_10',
    UTC_11 = 'UTC_11',
    UTC_12 = 'UTC_12',
    UTC_13 = 'UTC_13',
    UTC_14 = 'UTC_14',
    UTC_15 = 'UTC_15',
    UTC_16 = 'UTC_16',
    UTC_17 = 'UTC_17',
    UTC_18 = 'UTC_18',
    UTC_19 = 'UTC_19',
    UTC_20 = 'UTC_20',
    UTC_21 = 'UTC_21',
    UTC_22 = 'UTC_22',
    UTC_23 = 'UTC_23',
}
